import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");

class Command extends Base<any> {

    static about = `Opens an alert window to display a _message_.`;

    static options = {
        "message": {
            "about": "the message to show as an window alert"
        }
    }
    execute() {
        Utils.ifOption(this.options, "message", message => {
            window.alert(message);
            this.trigger();
        });
    }

}

export = Command;